import { Stack, Typography } from '@mui/material'
import { PublicMeetingCard } from './PublicMeetingCard'
import { TodaysMeetingsWebQuery } from 'src/gql/graphql'

interface Props {
  meetings: TodaysMeetingsWebQuery['todaysMeetings']
  selectMeeting: (
    meeting: TodaysMeetingsWebQuery['todaysMeetings'][0] | null,
  ) => void
}

export const PublicMeetingsList = ({ meetings, selectMeeting }: Props) => (
  <Stack
    justifyContent="center"
    direction="row"
    spacing={6}
    flexWrap="wrap"
    useFlexGap>
    {meetings.length ? (
      meetings.map(meeting => (
        <PublicMeetingCard
          key={meeting.id}
          publicMeeting={meeting}
          joinMeeting={() => selectMeeting(meeting)}
        />
      ))
    ) : (
      <Typography variant="h5" textAlign="center">
        No more meetings scheduled for today. Please check back tomorrow.
      </Typography>
    )}
  </Stack>
)
